import { bunja } from 'bunja';
import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import { instrumentBunja } from '../../../tpsl-modal/state/base';
import { SymbolScope } from '../../symbol/bunja';
import { ParentIdScope, PositionTypeScope, positionTpslBunja } from '../bunja';

const identity = <T>(value: T) => value;
/** trigger price(PrexDecimal 등 객체)를 문자열 값 기준으로 비교 — 값이 같으면 이전 identity 유지 */
const sameTriggerPrice = (a: unknown, b: unknown) => String(a) === String(b);

/**
 * TP/SL 버튼 전용 데이터 레이어.
 *
 * 스코프(symbol/positionType/parentId)는 컨테이너가 Context로 주입한다. 이 bunja가 그 식별자를
 * atom으로 노출하고, 표시에 필요한 tpsl 데이터(count·첫 주문·trigger price·slot·precision)도
 * positionTpslBunja/instrumentBunja에서 가져와 재노출한다.
 *
 * 덕분에 각 상태 컴포넌트는 position 객체를 받지 않고, 필요한 필드 atom만 bind 없이 구독한다.
 */
export const tpslButtonBunja = bunja(() => {
  const symbol = bunja.use(SymbolScope);
  const positionType = bunja.use(PositionTypeScope);
  const parentId = bunja.use(ParentIdScope);

  // 식별자는 스코프로 고정된 상수 — atom으로 감싸 소비를 통일한다(값이 바뀌지 않으므로 리렌더 없음).
  const symbolAtom = atom(() => symbol);
  const positionTypeAtom = atom(() => positionType);
  const parentIdAtom = atom(() => parentId);

  const {
    tpCountAtom,
    slCountAtom,
    tpFirstOrderAtom,
    slFirstOrderAtom,
    tpTriggerPriceAtom: rawTpTriggerPriceAtom,
    slTriggerPriceAtom: rawSlTriggerPriceAtom,
    slotAtom,
  } = bunja.use(positionTpslBunja);
  const { pricePrecisionAtom } = bunja.use(instrumentBunja);

  // trigger price는 PrexDecimal(객체)라 소켓 tick마다 값이 같아도 새 인스턴스로 온다.
  // Object.is dedup이 안 먹으므로 문자열 값 기준으로 dedup해 값이 실제 바뀐 tick에만 리렌더되게 한다.
  const tpTriggerPriceAtom = selectAtom(rawTpTriggerPriceAtom, identity, sameTriggerPrice);
  const slTriggerPriceAtom = selectAtom(rawSlTriggerPriceAtom, identity, sameTriggerPrice);

  return {
    symbolAtom,
    positionTypeAtom,
    parentIdAtom,
    tpCountAtom,
    slCountAtom,
    tpFirstOrderAtom,
    slFirstOrderAtom,
    tpTriggerPriceAtom,
    slTriggerPriceAtom,
    slotAtom,
    pricePrecisionAtom,
  };
});
tpslButtonBunja.debugLabel = 'tpslButtonBunja';
